

import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import {formMixin, formOptionsMixin, formValidationMixin} from "../mixins";
import Select from "./Select.vue";
import {getModule} from "vuex-module-decorators";
import {SystemModule} from "@/store/modules";
import _ from "lodash";

const systemModule = getModule(SystemModule);

@Component({
  components: {
    Select
  }
})

export default class DeliveryTypeSelect extends Mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {

  types: any[] = systemModule.deliveryTypes
    .filter(item => item.name)
    .map(x => ({ label: this.getDeliveryTypeNameText(x.name), value: x.id.trim() }));

  @Prop({default: false})
  appendToBody: boolean;

  @Prop()
  type: string;

  @Prop({default: false})
  isInactiveIncludeFacilities: boolean;

  @Prop({default: 0})
  deliveryForId: number;

  @Watch("deliveryForId")
  deliveryForChanged(newValue: number) {
    this.setDeliveryTypes(newValue);
  }

  created() {
    if(systemModule.deliveryFors.length > 0){
      this.setDeliveryTypes(systemModule.deliveryFors[0].id);
    }
  }

  setDeliveryTypes(value) {
    if(value == 0){
      this.types = systemModule.deliveryTypes
        .filter(item => item.name)
        .map(x => ({ label: this.getDeliveryTypeNameText(x.name), value: x.id.trim() }));
    } else {
      const items = _.filter(systemModule.allAgentDeliveryTypes, {agentId: value});
      this.types = _.map(items, x => ({
        label: this.getDeliveryTypeNameText(x.name) + " (" + x.orderType + ")", value: x.typeCode.trim()
      }));
    }
  }

  getDeliveryTypeNameText(deliveryTypeName) {
    return deliveryTypeName || "Delivery Type name not available";
  }
}
